import styled from 'styled-components'

export const Backdrop = styled.div`
  position: fixed;
  z-index: 1500;
  inset: 0;
  display: grid;
  padding: 20px;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: ${p => p.theme.palette.colors.backdrop};
  backdrop-filter: blur(8px);
  place-items: center;
`

export const Dialog = styled.div`
  width: min(620px, 100%);
  max-height: min(720px, calc(100vh - 40px));
  max-height: min(720px, calc(100dvh - 40px));
  box-sizing: border-box;
  overflow-y: auto;
  padding: clamp(22px, 4vw, 34px);
  border: 1px solid ${p => p.theme.palette.colors.borderStrong};
  border-radius: 22px;
  background: ${p => p.theme.palette.colors.surfaceElevatedStrong};
  box-shadow: 0 24px 70px ${p => p.theme.palette.colors.shadowStrong};
  color: ${p => p.theme.palette.colors.text};
  animation: analyticsDialog 0.24s ease both;

  @keyframes analyticsDialog { from { opacity: 0; transform: translateY(8px) scale(0.985); } to { opacity: 1; transform: none; } }
  @media (prefers-reduced-motion: reduce) { animation: none; }
`

export const Header = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 22px;
`

export const Title = styled.h2`margin: 0; font: 700 clamp(21px, 3vw, 28px)/1.2 Poppins, sans-serif; letter-spacing: -0.03em;`
export const Description = styled.p`margin: 8px 0 0; color: ${p => p.theme.palette.colors.muted}; font: 400 13px/1.55 Poppins, sans-serif;`
export const CloseButton = styled.button`
  width: 38px;
  height: 38px;
  flex: 0 0 auto;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 50%;
  background: ${p => p.theme.palette.colors.buttonGhost};
  color: ${p => p.theme.palette.colors.text};
  font: 400 22px/1 sans-serif;
  cursor: pointer;
  &:focus-visible { outline: 2px solid ${p => p.theme.palette.blue.main}; outline-offset: 2px; }
`

export const Options = styled.div`display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin-top: 28px; @media (max-width: 560px) { grid-template-columns: 1fr; }`
export const Option = styled.button`
  min-height: 132px;
  padding: 20px;
  border: 1px solid ${p => p.active ? p.theme.palette.blue.main : p.theme.palette.colors.borderSoft};
  border-radius: 16px;
  background: ${p => p.active ? p.theme.palette.colors.badgeMuted : p.theme.palette.colors.surfaceElevated};
  color: ${p => p.theme.palette.colors.text};
  text-align: left;
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;
  &:disabled { cursor: wait; }
  &:not(:disabled):hover { border-color: ${p => p.theme.palette.blue.main}; transform: translateY(-2px); }
  &:focus-visible { outline: 2px solid ${p => p.theme.palette.blue.main}; outline-offset: 2px; }
  @media (prefers-reduced-motion: reduce) { transition: none; }
`
export const OptionTitle = styled.strong`display: block; font: 700 15px/1.4 Poppins, sans-serif;`
export const OptionDescription = styled.span`display: block; margin-top: 7px; color: ${p => p.theme.palette.colors.muted}; font: 400 12px/1.55 Poppins, sans-serif;`
export const ErrorMessage = styled.p`margin: 18px 0 0; color: ${p => p.theme.palette.error.main}; font: 600 12px/1.5 Poppins, sans-serif;`
export const Actions = styled.footer`display: flex; justify-content: flex-end; gap: 12px; margin-top: 28px; @media (max-width: 480px) { flex-direction: column-reverse; > * { width: 100%; } }`
